import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
    <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
        <table class="data01" >
            <thead>
            <tr>
                <th>{{ 'search.Employee name' | translate }}</th>
                <!--<th class="todo">Position</th>-->
                <!--<th class="todo">Needed courses</th>-->
                <!--<th class="todo">Status</th>-->
            </tr>
            </thead>
            <tbody>
            <tr ng-repeat="employee in vm.list.items">
                <td><a ui-sref="authorized.user.employee.detail({ id: employee.id })">{{ employee.displayName }}</a></td>
                <!--<td class="todo"><p>Sales, Product manager, Junior</p><p>Sales, Safety instructor, Senior</p><p>Storage, Safety instructor, Junior</p></td>-->
                <!--<td class="todo">12</td>-->
                <!--<td class="todo">Working</td>-->
            </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
`
})
export default class {
    constructor ($state, SearchResource, ListFactory) {
        this.SearchResource = SearchResource;
        this.list = ListFactory.createWithPagination(SearchResource.getEmployees.bind(SearchResource));
        this.list.fetch({ keyword: $state.params.keyword });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/search/employees/index.js